export default __webpack_public_path__ + "static/dot-pattern-ee6f4f0e6654d6e38850896165f9dc36.svg";